import type { Country } from "src/api/interfaces/country";
import { redirectToAllowedPage } from "src/api/interfaces/pageUtils";
import {
  getRealmCookie,
  setCountryCodeCookie,
  setRealmCookie,
} from "src/cookies";
import { countryConfigMap } from "./countryConfig";

export const Realm = {
  EU: "EU",
  NA: "NA",
} as const;
export type Realm = (typeof Realm)[keyof typeof Realm];

export const DEFAULT_REALM = Realm.NA;

const RAW_REALM_TO_REALM: Record<string, Realm> = {
  EUAmazon: Realm.EU,
  USAmazon: Realm.NA,
};

export const normalizeRealm = (rawRealm: string): Realm =>
  RAW_REALM_TO_REALM[rawRealm] || DEFAULT_REALM;

export const setRealmBasedOnCountrySelection: (
  selectedCountry: Country | undefined
) => void = (selectedCountry) => {
  if (!selectedCountry) {
    setRealmCookie(getRealmCookie() ?? DEFAULT_REALM);
    return;
  }
  setCountryCodeCookie(selectedCountry.countryCode);
  setRealmCookie(
    countryConfigMap.get(selectedCountry.countryCode)?.realm || DEFAULT_REALM
  );
  redirectToAllowedPage();
};
